import ICallRequest from "./ICallRequest";
import CallRequestType from "./CallRequestTypeEnum";
import IHcDate from "./IHcDate";

export default class CallRequest implements ICallRequest {
    constructor(public dates: IHcDate[],
                public type: CallRequestType = CallRequestType.DATES) {
    }
}
